(() => {
  const componentOrder = ['base_1500', 'base_2000', 'base_3000', 'length_1000', 'length_500', 'length_250', 'revision_element', 'top_standard', 'top_raincap', 'rotovent_optional'];
  const compareCandidates = (a, b, targetMm = null) => {
    const deviation = targetMm === null ? 0 : Math.abs(a.effectiveHeightMm - targetMm) - Math.abs(b.effectiveHeightMm - targetMm);
    return deviation || a.partCount - b.partCount || b.quantities.length_1000 - a.quantities.length_1000 || b.quantities.length_500 - a.quantities.length_500 || a.quantities.length_250 - b.quantities.length_250;
  };
  const possibleConfigurations = (baseKey, topKey, heightModel, maximumHeightMm = 2200) => {
    const lengths = ['length_1000', 'length_500', 'length_250'];
    if ([baseKey, topKey, ...lengths].some((key) => heightModel[key]?.heightStatus !== 'confirmed')) return [];
    const fixedHeight = heightModel[baseKey].effectiveBuildHeightMm + heightModel[topKey].effectiveBuildHeightMm;
    const maxParts = Math.ceil((maximumHeightMm - fixedHeight) / heightModel.length_250.effectiveBuildHeightMm);
    const candidates = [];
    for (let qty1000 = 0; qty1000 <= maxParts; qty1000 += 1) for (let qty500 = 0; qty500 <= maxParts; qty500 += 1) for (let qty250 = 0; qty250 <= maxParts; qty250 += 1) {
      const partCount = qty1000 + qty500 + qty250;
      if (!partCount || partCount > maxParts) continue;
      const effectiveHeightMm = fixedHeight + qty1000 * heightModel.length_1000.effectiveBuildHeightMm + qty500 * heightModel.length_500.effectiveBuildHeightMm + qty250 * heightModel.length_250.effectiveBuildHeightMm;
      if (effectiveHeightMm <= maximumHeightMm) candidates.push({ baseKey, topKey, quantities: { length_1000: qty1000, length_500: qty500, length_250: qty250 }, effectiveHeightMm, partCount });
    }
    const unique = new Map();
    candidates.forEach((candidate) => {
      const customerTargetMm = Math.round(candidate.effectiveHeightMm / 10) * 10;
      const current = unique.get(customerTargetMm);
      if (!current || compareCandidates(candidate, current, customerTargetMm) < 0) unique.set(customerTargetMm, candidate);
    });
    return [...unique.values()].sort((a, b) => a.effectiveHeightMm - b.effectiveHeightMm);
  };
  const prepareHeightCandidates = (targetMm, baseKey, topKey, heightModel) => {
    const required = [baseKey, topKey];
    if (required.some((key) => heightModel[key]?.heightStatus !== 'confirmed')) return { status: 'blocked', reason: 'mandatory_height_unknown', candidates: [] };
    const lengths = ['length_1000', 'length_500', 'length_250'];
    if (lengths.some((key) => heightModel[key]?.heightStatus !== 'confirmed')) return { status: 'blocked', reason: 'length_height_unknown', candidates: [] };
    const fixedHeight = required.reduce((sum, key) => sum + heightModel[key].effectiveBuildHeightMm, 0);
    const candidates = [];
    const maxParts = Math.ceil(Math.max(0, targetMm - fixedHeight) / heightModel.length_250.effectiveBuildHeightMm) + 2;
    for (let qty1000 = 0; qty1000 <= maxParts; qty1000 += 1) for (let qty500 = 0; qty500 <= maxParts; qty500 += 1) for (let qty250 = 0; qty250 <= maxParts; qty250 += 1) {
      const partCount = qty1000 + qty500 + qty250;
      if (!partCount || partCount > maxParts) continue;
      const effectiveHeightMm = fixedHeight + qty1000 * heightModel.length_1000.effectiveBuildHeightMm + qty500 * heightModel.length_500.effectiveBuildHeightMm + qty250 * heightModel.length_250.effectiveBuildHeightMm;
      candidates.push({ quantities: { length_1000: qty1000, length_500: qty500, length_250: qty250 }, effectiveHeightMm, deviationMm: effectiveHeightMm - targetMm, partCount });
    }
    candidates.sort((a, b) => compareCandidates(a, b, targetMm));
    return { status: 'prepared', candidates: candidates.slice(0, 10) };
  };
  const diameterOf = (variant) => {
    const option = (variant.options || []).find((value) => /\d{3}/.test(value));
    return option ? (option.match(/\d{3}/) || [])[0] : null;
  };
  const variantFor = (component, diameter) => component?.product?.variants.find((variant) => diameterOf(variant) === diameter) || null;
  const formatMoney = (cents, format) => {
    const value = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}|\{\{\s*amount\s*\}\}/, value);
  };
  document.querySelectorAll('.msp-height-config').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('.msp-height-config__data').textContent);
    const configurations = possibleConfigurations('base_1500', 'top_standard', config.heightModel || {});
    root.mspHeightPlanning = Object.freeze({ enabled: config.heightCalculationEnabled === true, calculate: (targetMm, baseKey, topKey) => prepareHeightCandidates(targetMm, baseKey, topKey, config.heightModel || {}) });
    const open = root.querySelector('.msp-height-config__open') || document.querySelector(`[data-msp-height-config-trigger="${root.id}"]`);
    const panel = root.querySelector('.msp-height-config__panel');
    const modal = root.closest('[data-msp-height-config-modal]');
    const modalClose = modal?.querySelector('.msp-height-modal__close');
    const diameterSelect = root.querySelector('.msp-height-config__diameter');
    const heightSelect = root.querySelector('.msp-height-config__height');
    const revisionInputs = [...root.querySelectorAll('input[name^="revision-"]')];
    const rotovent = root.querySelector('.msp-height-config__rotovent');
    const compatibility = root.querySelector('.msp-height-config__compatibility');
    const lines = root.querySelector('.msp-height-config__lines');
    const actualHeight = root.querySelector('.msp-height-config__actual-height');
    const total = root.querySelector('.msp-height-config__total strong');
    const status = root.querySelector('.msp-height-config__status');
    const cart = root.querySelector('.msp-height-config__cart');
    let cartLines = [];
    let isAddingToCart = false;
    heightSelect.replaceChildren(...configurations.map((candidate, index) => new Option(`ca. ${(candidate.effectiveHeightMm / 1000).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m – tatsächlich ${candidate.effectiveHeightMm} mm`, String(index))));
    if (!configurations.length) heightSelect.add(new Option('Keine bestätigte Höhenkombination verfügbar', ''));
    const requiredKeys = ['base_1500', 'length_1000', 'length_500', 'length_250', 'top_standard'];
    const commonDiameters = ['130', '150', '160', '180', '200'].filter((diameter) => requiredKeys.every((key) => variantFor(config.components[key], diameter)));
    diameterSelect.replaceChildren(...commonDiameters.map((diameter) => new Option(`Ø ${diameter} mm`, diameter)));
    if (!commonDiameters.length) diameterSelect.add(new Option('Keine gemeinsame Variante verfügbar', ''));
    const render = () => {
      const diameter = diameterSelect.value;
      const selectedTop = root.querySelector('input[name^="top-"]:checked').value;
      const revisionSelected = root.querySelector('input[name^="revision-"]:checked')?.value === 'with';
      const raincapSelected = selectedTop === 'top_raincap';
      if (raincapSelected && rotovent.checked) rotovent.checked = false;
      rotovent.disabled = raincapSelected;
      rotovent.closest('.msp-height-config__check').classList.toggle('msp-height-config__check--disabled', raincapSelected);
      const selected = configurations[Number(heightSelect.value)];
      const quantities = selected ? { [selected.baseKey]: 1, ...selected.quantities, [selectedTop]: 1 } : {};
      ['length_1000', 'length_500', 'length_250'].forEach((key) => { if (!quantities[key]) delete quantities[key]; });
      if (revisionSelected) quantities.revision_element = 1;
      if (rotovent.checked) quantities.rotovent_optional = 1;
      lines.replaceChildren();
      cartLines = [];
      let sum = 0;
      let complete = Boolean(diameter);
      let available = true;
      const sketchParts = [];
      Object.entries(quantities).sort(([keyA], [keyB]) => componentOrder.indexOf(keyA) - componentOrder.indexOf(keyB)).forEach(([key, quantity]) => {
        const component = config.components[key];
        const variant = variantFor(component, diameter);
        const row = document.createElement('div');
        row.className = 'msp-height-config__line';
        row.dataset.componentKey = key;
        const label = document.createElement('label');
        label.textContent = `${component.label} × ${quantity}`;
        const detail = document.createElement('em');
        detail.textContent = component.product?.title || 'Nicht im Theme-Editor hinterlegt';
        const price = document.createElement('strong');
        if (!variant) {
          complete = false;
          price.textContent = 'Nicht verfügbar';
        } else if (!variant.available) {
          available = false;
          price.textContent = 'Nicht verfügbar';
        } else {
          const linePrice = Number(variant.price) * Number(quantity);
          sum += linePrice;
          price.textContent = formatMoney(linePrice, config.moneyFormat);
          cartLines.push({ id: Number(variant.id), quantity: Number(quantity), properties: { _Konfiguration: 'Schornsteinerhöhung', _Durchmesser: `Ø ${diameter} mm` } });
        }
        sketchParts.push({ key, label: component.label, quantity: Number(quantity), diameter, variantId: variant?.id || '' });
        row.append(label, detail, price);
        row.tabIndex = 0;
        row.addEventListener('mouseenter', () => root.dispatchEvent(new CustomEvent('msp:component-highlight', { detail: { key } })));
        row.addEventListener('mouseleave', () => root.dispatchEvent(new CustomEvent('msp:component-highlight', { detail: { key: '' } })));
        row.addEventListener('focusin', () => root.dispatchEvent(new CustomEvent('msp:component-highlight', { detail: { key } })));
        row.addEventListener('focusout', () => root.dispatchEvent(new CustomEvent('msp:component-highlight', { detail: { key: '' } })));
        lines.append(row);
      });
      const rotoventCompatible = !rotovent.checked || Boolean(variantFor(config.components.rotovent_optional, diameter));
      if (!rotoventCompatible) complete = false;
      compatibility.textContent = raincapSelected ? 'Rotovent ist nur mit normalem Mündungsabschluss möglich.' : rotovent.checked && !rotoventCompatible ? `Rotovent ist für Ø ${diameter} mm nicht hinterlegt.` : '';
      total.textContent = complete && available ? formatMoney(sum, config.moneyFormat) : '–';
      const heightKnown = selected && !revisionSelected;
      actualHeight.textContent = revisionSelected ? 'Aufbauhöhe mit Reinigungsöffnung noch nicht vollständig bestätigt.' : heightKnown ? `Tatsächliche Aufbauhöhe: ${selected.effectiveHeightMm} mm` : 'Tatsächliche Aufbauhöhe: für diesen Abschluss/Aufsatz noch nicht bestätigt';
      const cartReady = complete && available && cartLines.length === Object.keys(quantities).length && cartLines.length > 0 && cartLines.every((line) => Number.isInteger(line.quantity) && line.quantity > 0);
      if (!cartReady) cartLines = [];
      cart.disabled = !cartReady || isAddingToCart;
      if (!isAddingToCart) cart.textContent = 'KOMPLETT IN DEN WARENKORB';
      status.textContent = !complete ? 'Diese Kombination ist nicht vollständig oder nicht durchgehend im gewählten Durchmesser verfügbar.' : !available ? 'Mindestens eine benötigte Variante ist derzeit nicht verfügbar.' : 'Technisch vollständig und bereit für den Warenkorb.';
      root.dispatchEvent(new CustomEvent('msp:height-config-updated', { detail: { parts: sketchParts, diameter, heightMm: heightKnown ? selected.effectiveHeightMm : null, heightNote: revisionSelected ? 'Aufbauhöhe mit Reinigungsöffnung noch nicht vollständig bestätigt.' : '' } }));
    };
    const closeModal = () => {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      panel.hidden = true;
      open.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('msp-height-modal-open');
      open.focus();
    };
    open.addEventListener('click', () => {
      if (modal) {
        modal.hidden = false;
        panel.hidden = false;
        open.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('msp-height-modal-open');
        render();
        modalClose.focus();
        return;
      }
      const expanded = open.getAttribute('aria-expanded') === 'true';
      open.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      open.textContent = expanded ? 'JETZT KONFIGURIEREN' : 'KONFIGURATOR SCHLIESSEN';
      if (!expanded) render();
    });
    modalClose?.addEventListener('click', closeModal);
    modal?.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
    document.addEventListener('keydown', (event) => { if (modal && !modal.hidden && event.key === 'Escape') closeModal(); });
    [diameterSelect, heightSelect, rotovent, ...revisionInputs, ...root.querySelectorAll('input[name^="top-"]')].forEach((input) => input.addEventListener('change', render));
    cart.addEventListener('click', async () => {
      if (isAddingToCart || cart.disabled || !cartLines.length) return;
      const items = cartLines.map((line) => ({ ...line, properties: { ...line.properties } }));
      isAddingToCart = true;
      cart.disabled = true;
      cart.textContent = 'WIRD HINZUGEFÜGT…';
      status.textContent = 'Die vollständige Konfiguration wird in den Warenkorb gelegt…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || `HTTP ${response.status}`);
        status.textContent = 'Die vollständige Konfiguration wurde in den Warenkorb gelegt.';
        document.dispatchEvent(new CustomEvent('msp:cart-refresh'));
        window.dispatchEvent(new CustomEvent('cartUpdated', { detail: result }));
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.renderContents && result.sections) drawer.renderContents(result);
      } catch (error) {
        console.error('[MSP Schornsteinerhöhung Warenkorb]', error);
        status.textContent = 'Die Konfiguration konnte nicht in den Warenkorb gelegt werden. Bitte prüfen Sie Ihre Auswahl und versuchen Sie es erneut.';
      } finally {
        isAddingToCart = false;
        cart.disabled = !cartLines.length;
        cart.textContent = 'KOMPLETT IN DEN WARENKORB';
      }
    });
  });
})();
